<div class="h-full flex w-full p-2 gap-2">
    <!-- Left Sidebar - Document Types -->
    <div class="border border-gray-200 rounded-base w-[20%]">
        <div class="flex flex-col gap-1 p-2 border-b border-gray-200">
            <h3 class="text-sm font-semibold text-gray-900">Document Type</h3>
            <app-select [(value)]="selectedDocumentType" [options]="documentTypeOptions" [config]="documentTypeConfig"
                [itemTemplate]="documentTypeItem" (onChange)="selectDocumentType($event.value)">
            </app-select>

            <ng-template #documentTypeItem let-option>
                <div class="text-sm py-0.5">
                    {{ option.label }}
                </div>
            </ng-template>
        </div>
        <div class="p-2 h-full">
            <h3 class="text-sm font-semibold text-gray-900">Questions</h3>
            @for(cluster of duplicateClusterOptions; track $index) {
            <div class="flex items-center justify-between p-2 rounded-base cursor-pointer  transition-colors"
                [ngClass]="selectedDuplicateCluster()?.clusterId === cluster.clusterId ? 'bg-arena-orange-100' : 'text-gray-700'"
                (click)="selectDuplicateCluster(cluster)">
                <div class="flex items-center justify-between w-full gap-1.5 min-w-0">
                    <div class="text-sm truncate" pTooltip="{{cluster.title}}" tooltipPosition="bottom">{{ cluster.title
                        }}</div>
                    <div class="text-sm flex-shrink-0">({{ cluster.count }})</div>
                </div>
            </div>
            }
        </div>
    </div>

    <!-- Right Side - Table -->
    <div class="w-[80%] gap-4 flex flex-col overflow-scroll ">
        @if(selectedQuestions.length > 0){
        <div class="flex justify-between border rounded-base p-2 border-gray-200 items-center">
            <div class="flex gap-2 selection-count text-md">
                <span *ngIf="!isSelectAll" class="flex items-center gap-2">{{ selectedQuestions.length }} items
                    selected</span>
                <span *ngIf="isSelectAll" class="flex items-center gap-2">
                    <span>All {{ duplicateQnaPairs.length }} items selected</span>
                </span>
                <div class="border-l border-gray-300 h-auto mx-2"></div>
                <app-button label="Edit Answer" variant="outlined" icon="pi pi-pen-to-square"
                    (clicked)="openBulkEditDialog()" />
                @if(selectedQuestions.length > 1){
                <app-button label="Merge Answers" variant="outlined" icon="pi pi-pen-to-square"
                    (clicked)="openMergeDialog()" />
                }
                <app-button label="Mark Not Duplicate" variant="outlined" icon="pi pi-pen-to-square"
                    (clicked)="markNotDuplicateQuestion($event)" />
            </div>
            <div class="action-buttons flex items-center gap-2">
                <app-button label="Delete" variant="outlined" icon="pi pi-trash" (clicked)="deleteQuestion($event)"
                    severity="danger" />
                @if(selectedQuestions.length == 1){
                <app-button label="Accept" variant="outlined" icon="pi pi-check" (clicked)="acceptQuestion($event)"
                    severity="success" />
                }
            </div>
        </div>
        } @else if(selectedDuplicateCluster()) {
        <h2 class="text-sm font-semibold text-gray-900">{{selectedDuplicateCluster()?.title}}</h2>
        }
        <div class="flex flex-col gap-2 w-full overflow-x-auto">
            <div class="border flex-1 rounded-base w-full">
                <!-- Table header -->
                <div class="bg-gray-50 border-b border-gray-200">
                    <div class="flex w-full text-sm">
                        <div class="w-16 min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center justify-center">
                                <app-checkbox [(value)]="selectAllChecked" (onChange)="toggleSelectAll($event)"
                                    [config]="{ binary: true }" />
                            </div>
                        </div>
                        <div class="flex-[2] min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Question</span>
                            </div>
                        </div>
                        <div class="flex-[3] min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Answer</span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Times Used</span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Source Type</span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Author</span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-[4rem] p-3 border-r border-gray-200">
                            <div class="flex items-center">
                                <span class="font-semibold ">Last Edited</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Table body -->
                <div class="overflow-y-auto overflow-x-hidden" style="height: calc(100vh - 18rem);">
                    <!-- Loading state -->
                    @if(duplicateClusterLoading) {
                    <div class="flex justify-center items-center py-8">
                        <p-progressSpinner class="w-6 h-6"></p-progressSpinner>
                        <span class="ml-2 text-sm text-gray-600">Loading data...</span>
                    </div>
                    }

                    <!-- Empty state -->
                    @if(!duplicateClusterLoading && duplicateQnaPairs.length === 0) {
                    <div class="flex justify-center items-center py-8">
                        <span class="text-gray-500">No data available</span>
                    </div>
                    }

                    @for(qna of duplicateQnaPairs; track qna._id) {
                    <div class="flex w-full h-14 border-b border-gray-200 hover:bg-gray-50"
                        [ngClass]="getRowClass(qna)">
                        <div class="w-16 min-w-[4rem] flex justify-center items-center border-r border-gray-200">
                            <app-checkbox [value]="isSelected(qna)" (onChange)="toggleRowSelection(qna, $event)"
                                [config]="{ binary: true }" />
                        </div>
                        <div class="flex-[2] min-w-[4rem] p-3 border-r border-gray-200 group">
                            <div class="relative w-full h-full">
                                <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                                    (click)="openModel(getQuestionTitle(qna), 'Question')"></i>
                                <div class="line-clamp-2 text-sm overflow-hidden">{{ getQuestionTitle(qna) }}</div>
                            </div>
                        </div>
                        <div class="flex-[3] min-w-[4rem] p-3 border-r border-gray-200 overflow-hidden">
                            <div class="relative w-full h-full group">
                                <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                                    (click)="openModel(getAnswerValue(qna), 'Answer')"></i>
                                <i class="pi pi-copy absolute top-1 right-7 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                                    (click)="copyAnswerToClipboard(qna)"></i>
                                <div class="prose prose-compact text-justify text-sm prose-ul:pl-1 prose-ol:pl-2 2xl:prose-ul:pl-4 2xl:prose-ol:pl-3 sm:prose-ul:pl-3 h-full overflow-y-auto"
                                    [innerHTML]="getAnswerValue(qna) | formatText : false" dynamicComponentRenderer
                                    style="line-height:1.5rem;">
                                </div>
                            </div>
                        </div>
                        <div
                            class="flex-1 min-w-[4rem] p-3 border-r border-gray-200 flex items-start overflow-hidden text-sm text-ellipsis">
                            {{ getTimesUsed(qna) }}
                        </div>
                        <div
                            class="flex-1 min-w-[4rem] p-3 border-r border-gray-200 flex items-start overflow-hidden text-sm text-ellipsis">
                            {{ getSourceType(qna) }}
                        </div>
                        <div
                            class="flex-1 min-w-[4rem] p-3 border-r border-gray-200 flex items-start overflow-hidden text-sm text-ellipsis">
                            <app-user-name-display [user]="qna.author" [fallbackText]="getAuthorName(qna)" />
                        </div>
                        <div
                            class="flex-1 min-w-[4rem] p-3 flex items-start border-r border-gray-200 overflow-hidden text-sm text-ellipsis">
                            {{ getLastEdited(qna) }}
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<app-dialog [(visible)]="expandCell" [title]="expandedCellType" (closed)="expandCell = false" class="max-w-[80vw]"
    [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="prose prose-compact text-justify text-md prose-ul:pl-1 prose-ol:pl-2 overflow-x-auto px-4 pb-2"
            [innerHTML]="expandedCellContent | formatText : false" dynamicComponentRenderer style="line-height:1.5rem;">
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showBulkEditDialog" (closed)="closeBulkEditDialog()"
    class="max-w-[70vw] h-[70vh]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2">
            <span class="font-semibold text-lg">Edit Q&amp;A</span>
            <span class="text-sm text-gray-600">({{ currentEditIndex + 1 }}/{{ editingPairs.length }})</span>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between p-4 gap-4">
            <div class="h-full w-[40%]">
                <div class="qna-cards-container mb-4">
                    <div #qnaCard *ngFor="let pair of editingPairs; let i = index"
                        class="qna-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectQnaPair(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">{{ pair.question }}</div>
                            <div class="text-xs text-gray-600 truncate">{{ pair.answer }}</div>
                        </div>
                        <div>
                            @if(savedPairs.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if(currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-full w-[60%]">
                <div *ngIf="editingPairs[currentEditIndex]"
                    class="flex flex-col border-2 border-gray-100 rounded-base p-4 h-full">
                    <div class="field">
                        <label for='question' class="flex text-sm font-medium mb-2">Question</label>
                        <textarea id='question' pInputTextarea [(ngModel)]="editingPairs[currentEditIndex].question"
                            class="w-full" rows="3" placeholder="Enter question..." [disabled]="true"></textarea>
                    </div>
                    <div class="field">
                        <label for='bulkEditAnswer' class="flex text-sm font-medium mb-2">Answer</label>
                        <textarea id='bulkEditAnswer' pInputTextarea [(ngModel)]="editingPairs[currentEditIndex].answer"
                            (ngModelChange)="savePair(currentEditIndex)" class="w-full" rows="5"
                            placeholder="Enter answer..."></textarea>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button icon="pi pi-chevron-left" variant="outlined" label="Prev" [disabled]="isPreviousDisabled"
                    (clicked)="navigatePrevious()" iconPos="left" />
                <app-button icon="pi pi-chevron-right" variant="outlined" label="Next" [disabled]="isNextDisabled"
                    (clicked)="navigateNext()" iconPos="right" />
            </div>
            <div class="flex gap-2">
                <app-button label="Save" variant="filled" icon="pi pi-save" (clicked)="onSaveBulkEdit()"
                    [disabled]="isSaveDisabled" [loading]="isSaving" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showMergeDialog" title="Merge Answers" (closed)="closeMergeDialog()"
    class="max-w-[50vw] h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full flex flex-col p-4 gap-4 overflow-scroll">
            <p-accordion [multiple]="true" class="border-accordion gap-accordion">
                @for(pair of mergePairs; track pair._id; let i = $index) {
                <p-accordion-panel [value]="i.toString()">
                    <p-accordion-header>
                        <div class="flex items-center gap-2">
                            <div (click)="$event.stopPropagation()">
                                <app-checkbox [value]="mergePairsSelected.has(pair._id)"
                                    (onChange)="selectMergeAnswer(pair._id)" [config]="{ binary: true }" />
                            </div>
                            <div>
                                <div class="text-gray-600">{{ getMergeQuestion(pair) }}</div>
                            </div>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="text-gray-600">{{ getMergeAnswer(pair) }}</div>
                    </p-accordion-content>
                </p-accordion-panel>
                }
            </p-accordion>
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <label class="text-lg font-bold">Smart Suggestion</label>
                    @if(mergeSuggestionLoading){
                    <p-progressSpinner strokeWidth="4" [style]="{width: '20px', height: '20px'}" />
                    }
                </div>
                @if(!mergeSuggestionLoading && selectedMergeQuestionsChanged){
                <i class="pi pi-refresh cursor-pointer text-arena-orange" (click)="getMergeSmartSuggestion()"></i>
                }
            </div>
            <div class="gap-2">
                <label class="text-sm font-medium">Question</label>
                <textarea pInputTextarea [(ngModel)]="suggestion.question" class="w-full ai-suggestion"
                    rows="3"></textarea>
                <label class="text-sm font-medium">Answer</label>
                <textarea pInputTextarea [(ngModel)]="suggestion.answer" class="w-full ai-suggestion"
                    rows="3"></textarea>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Accept &amp; Save" variant="outlined" icon="pi pi-check"
                (clicked)="saveMergeAnswerPrompt()" [loading]="savingMergeAnswer"
                [disabled]="mergeSuggestionLoading || savingMergeAnswer" />
            <app-button label="Save Answers" variant="filled" icon="pi pi-save" (clicked)="saveMergeAnswer()"
                [loading]="savingMergeAnswer" [disabled]="mergeSuggestionLoading || savingMergeAnswer"
                severity="primary" />
        </div>
    </ng-template>
</app-dialog>